<template>
    <div id="form-three" class="form">
        <fieldset>
            <legend>您的資產背景</legend>
            <div class="one-line slider">
              <span v-if="client_annual_income == ''">年度收入（美元）</span>
              <span v-if="client_annual_income && client_annual_income === value.value" v-for="value in usdAmountList[0].option">
                  {{value.displayName}}
              </span>
               <div class="radio-select-slider-container range">
                    <span class="radio-select-slider" v-for="(radio, index) in usdAmountList[0].option">
                        <input type="radio" :value="radio.value" :id="'annual-income-radio-btn' + index" name="Client[client_annual_income]" v-validate="{required_choose: true, required: true}" v-model="client_annual_income" :data-vv-as="[index == 0 ? '年度收入（美元）' : null]">
                        <label :for="'annual-income-radio-btn' + index"></label>
                        <span class="switcher">|||</span>
                    </span>
                   <span class="scale-container">
                       <span  v-for="scale in usdAmountList[0].scale"><span>{{scale.displayName}}</span></span>
                   </span>
               </div>
               <span :class="{'invalid': errors.has('signup_agent_form.Client[client_annual_income]'), 'valid': !errors.has('signup_agent_form.Client[client_annual_income]')}">{{errors.first('signup_agent_form.Client[client_annual_income]')}}<span v-if="(!errors.has('signup_agent_form.Client[client_annual_income]') && client_annual_income.length > 0)">年度收入（美元）</span></span>
            </div>
            <div class="one-line slider">
              <span v-if="client_net_current_assets == ''">流動資產淨值（美元）</span>
              <span v-if="client_net_current_assets && client_net_current_assets === value.value" v-for="value in usdAmountList[0].option">
                  {{value.displayName}}
              </span>
               <div class="radio-select-slider-container range">
                    <span class="radio-select-slider" v-for="(radio, index) in usdAmountList[0].option">
                        <input type="radio" :value="radio.value" :id="'net-current-assets-radio-btn' + index" name="Client[client_net_current_assets]" v-validate="{required_choose: true, required: true}" v-model="client_net_current_assets" :data-vv-as="[index == 0 ? '流動資產淨值（美元）' : null]">
                        <label :for="'net-current-assets-radio-btn' + index"></label>
                        <span class="switcher">|||</span>
                    </span>
                   <span class="scale-container">
                       <span  v-for="scale in usdAmountList[0].scale"><span>{{scale.displayName}}</span></span>
                   </span>
               </div>
               <span :class="{'invalid': errors.has('signup_agent_form.Client[client_net_current_assets]'), 'valid': !errors.has('signup_agent_form.Client[client_net_current_assets]')}">{{errors.first('signup_agent_form.Client[client_net_current_assets]')}}<span v-if="(!errors.has('signup_agent_form.Client[client_net_current_assets]') && client_net_current_assets.length > 0)">流動資產淨值（美元）</span></span>
            </div>
            <div class="one-line slider">
              <span v-if="client_total_assets == ''">總資產（美元）</span>
              <span v-if="client_total_assets && client_total_assets === value.value" v-for="value in usdAmountList[0].option">
                  {{value.displayName}}
              </span>
               <div class="radio-select-slider-container range">
                    <span class="radio-select-slider" v-for="(radio, index) in usdAmountList[0].option">
                        <input type="radio" :value="radio.value" :id="'total-assets-radio-btn' + index" name="Client[client_total_assets]" v-validate="{required_choose: true, required: true}" v-model="client_total_assets" :data-vv-as="[index == 0 ? '總資產（美元）' : null]">
                        <label :for="'total-assets-radio-btn' + index"></label>
                        <span class="switcher">|||</span>
                    </span>
                   <span class="scale-container">
                       <span  v-for="scale in usdAmountList[0].scale"><span>{{scale.displayName}}</span></span>
                   </span>
               </div>
               <span :class="{'invalid': errors.has('signup_agent_form.Client[client_total_assets]'), 'valid': !errors.has('signup_agent_form.Client[client_total_assets]')}">{{errors.first('signup_agent_form.Client[client_total_assets]')}}<span v-if="(!errors.has('signup_agent_form.Client[client_total_assets]') && client_total_assets.length > 0)">總資產（美元）</span></span>
            </div>
        </fieldset>
        <fieldset>
            <legend>您的投資經驗</legend>
            <div class="one-line slider">
              <span v-if="client_inv_kno == ''">投資知識</span>
              <span v-if="client_inv_kno && client_inv_kno === value.value" v-for="value in invKnoList">
                  {{value.displayName}}
              </span>
               <div class="radio-select-slider-container progressive three">
                    <span class="radio-select-slider" v-for="(radio, index) in invKnoList">
                        <input type="radio" :value="radio.value" :id="'inv-kno-radio-btn' + index" name="Client[client_inv_kno]" v-validate="{required_choose: true, required: true}" v-model="client_inv_kno" :data-vv-as="[index == 0 ? '投資知識' : null]">
                        <label :for="'inv-kno-radio-btn' + index"><span>{{radio.displayName}}</span></label>
                    </span>
               </div>
               <span :class="{'invalid': errors.has('signup_agent_form.Client[client_inv_kno]'), 'valid': !errors.has('signup_agent_form.Client[client_inv_kno]')}">{{errors.first('signup_agent_form.Client[client_inv_kno]')}}<span v-if="(!errors.has('signup_agent_form.Client[client_inv_kno]') && client_inv_kno.length > 0)">投資知識</span></span>
            </div>
            <div class="one-line slider">
              <span v-if="client_inv_exp_exchange == ''">外匯投資經驗之年數</span>
              <span v-if="client_inv_exp_exchange && client_inv_exp_exchange === value.value" v-for="value in invExpList">
                  {{value.value}}
              </span>
               <div class="radio-select-slider-container progressive seven">
                    <span class="radio-select-slider" v-for="(radio, index) in invExpList">
                        <input type="radio" :value="radio.value" :id="'inv-exp-exchange-radio-btn' + index" name="Client[client_inv_exp_exchange]" v-validate="{required_choose: true, required: true}" v-model="client_inv_exp_exchange" :data-vv-as="[index == 0 ? '外匯投資經驗之年數' : null]">
                        <label :for="'inv-exp-exchange-radio-btn' + index"><span>{{radio.displayName}}</span></label>
                    </span>
               </div>
               <span :class="{'invalid': errors.has('signup_agent_form.Client[client_inv_exp_exchange]'), 'valid': !errors.has('signup_agent_form.Client[client_inv_exp_exchange]')}">{{errors.first('signup_agent_form.Client[client_inv_exp_exchange]')}}<span v-if="(!errors.has('signup_agent_form.Client[client_inv_exp_exchange]') && client_inv_exp_exchange.length > 0)">外匯投資經驗之年數</span></span>
            </div>
            <div class="one-line slider">
              <span v-if="client_inv_exp_option == ''">期權投資經驗之年數</span>
              <span v-if="client_inv_exp_option && client_inv_exp_option === value.value" v-for="value in invExpList">
                  {{value.value}}
              </span>
               <div class="radio-select-slider-container progressive seven">
                    <span class="radio-select-slider" v-for="(radio, index) in invExpList">
                        <input type="radio" :value="radio.value" :id="'inv-exp-option-radio-btn' + index" name="Client[client_inv_exp_option]" v-validate="{required_choose: true, required: true}" v-model="client_inv_exp_option" :data-vv-as="[index == 0 ? '期權投資經驗之年數' : null]">
                        <label :for="'inv-exp-option-radio-btn' + index"><span>{{radio.displayName}}</span></label>
                    </span>
               </div>
               <span :class="{'invalid': errors.has('signup_agent_form.Client[client_inv_exp_option]'), 'valid': !errors.has('signup_agent_form.Client[client_inv_exp_option]')}">{{errors.first('signup_agent_form.Client[client_inv_exp_option]')}}<span v-if="(!errors.has('signup_agent_form.Client[client_inv_exp_option]') && client_inv_exp_option.length > 0)">期權投資經驗之年數</span></span>
            </div>
            <div class="one-line slider">
              <span v-if="client_inv_exp_securities == ''">證劵投資經驗之年數</span>
              <span v-if="client_inv_exp_securities && client_inv_exp_securities === value.value" v-for="value in invExpList">
                  {{value.value}}
              </span>
               <div class="radio-select-slider-container progressive seven">
                    <span class="radio-select-slider" v-for="(radio, index) in invExpList">
                        <input type="radio" :value="radio.value" :id="'inv-exp-securities-radio-btn' + index" name="Client[client_inv_exp_securities]" v-validate="{required_choose: true, required: true}" v-model="client_inv_exp_securities" :data-vv-as="[index == 0 ? '證劵投資經驗之年數' : null]">
                        <label :for="'inv-exp-securities-radio-btn' + index"><span>{{radio.displayName}}</span></label>
                    </span>
               </div>
               <span :class="{'invalid': errors.has('signup_agent_form.Client[client_inv_exp_securities]'), 'valid': !errors.has('signup_agent_form.Client[client_inv_exp_securities]')}">{{errors.first('signup_agent_form.Client[client_inv_exp_securities]')}}<span v-if="(!errors.has('signup_agent_form.Client[client_inv_exp_securities]') && client_inv_exp_securities.length > 0)">證劵投資經驗之年數</span></span>
            </div>
            <div class="one-line slider">
              <span v-if="client_inv_exp_futures == ''">期貨投資經驗之年數</span>
              <span v-if="client_inv_exp_futures && client_inv_exp_futures === value.value" v-for="value in invExpList">
                  {{value.value}}
              </span>
               <div class="radio-select-slider-container progressive seven">
                    <span class="radio-select-slider" v-for="(radio, index) in invExpList">
                        <input type="radio" :value="radio.value" :id="'inv-exp-futures-radio-btn' + index" name="Client[client_inv_exp_futures]" v-validate="{required_choose: true, required: true}" v-model="client_inv_exp_futures" :data-vv-as="[index == 0 ? '期貨投資經驗之年數' : null]">
                        <label :for="'inv-exp-futures-radio-btn' + index"><span>{{radio.displayName}}</span></label>
                    </span>
               </div>
               <span :class="{'invalid': errors.has('signup_agent_form.Client[client_inv_exp_futures]'), 'valid': !errors.has('signup_agent_form.Client[client_inv_exp_futures]')}">{{errors.first('signup_agent_form.Client[client_inv_exp_futures]')}}<span v-if="(!errors.has('signup_agent_form.Client[client_inv_exp_futures]') && client_inv_exp_futures.length > 0)">期貨投資經驗之年數</span></span>
            </div>
            <div class="one-line slider">
              <span v-if="client_inv_exp_fund == ''">基金投資經驗之年數</span>
              <span v-if="client_inv_exp_fund && client_inv_exp_fund === value.value" v-for="value in invExpList">
                  {{value.value}}
              </span>
               <div class="radio-select-slider-container progressive seven">
                    <span class="radio-select-slider" v-for="(radio, index) in invExpList">
                        <input type="radio" :value="radio.value" :id="'inv-exp-fund-radio-btn' + index" name="Client[client_inv_exp_fund]" v-validate="{required_choose: true, required: true}" v-model="client_inv_exp_fund" :data-vv-as="[index == 0 ? '基金投資經驗之年數' : null]">
                        <label :for="'inv-exp-fund-radio-btn' + index"><span>{{radio.displayName}}</span></label>
                    </span>
               </div>
               <span :class="{'invalid': errors.has('signup_agent_form.Client[client_inv_exp_fund]'), 'valid': !errors.has('signup_agent_form.Client[client_inv_exp_fund]')}">{{errors.first('signup_agent_form.Client[client_inv_exp_fund]')}}<span v-if="(!errors.has('signup_agent_form.Client[client_inv_exp_fund]') && client_inv_exp_fund.length > 0)">基金投資經驗之年數</span></span>
            </div>
            <div class="one-line slider">
              <span v-if="client_inv_exp_bonds == ''">債劵投資經驗之年數</span>
              <span v-if="client_inv_exp_bonds && client_inv_exp_bonds === value.value" v-for="value in invExpList">
                  {{value.value}}
              </span>
               <div class="radio-select-slider-container progressive seven">
                    <span class="radio-select-slider" v-for="(radio, index) in invExpList">
                        <input type="radio" :value="radio.value" :id="'inv-exp-bonds-radio-btn' + index" name="Client[client_inv_exp_bonds]" v-validate="{required_choose: true, required: true}" v-model="client_inv_exp_bonds" :data-vv-as="[index == 0 ? '債劵投資經驗之年數' : null]">
                        <label :for="'inv-exp-bonds-radio-btn' + index"><span>{{radio.displayName}}</span></label>
                    </span>
               </div>
               <span :class="{'invalid': errors.has('signup_agent_form.Client[client_inv_exp_bonds]'), 'valid': !errors.has('signup_agent_form.Client[client_inv_exp_bonds]')}">{{errors.first('signup_agent_form.Client[client_inv_exp_bonds]')}}<span v-if="(!errors.has('signup_agent_form.Client[client_inv_exp_bonds]') && client_inv_exp_bonds.length > 0)">債劵投資經驗之年數</span></span>
            </div>
            <div class="one-line slider">
              <span v-if="client_inv_exp_commodity == ''">商品投資經驗之年數</span>
              <span v-if="client_inv_exp_commodity && client_inv_exp_commodity === value.value" v-for="value in invExpList">
                  {{value.value}}
              </span>
               <div class="radio-select-slider-container progressive seven">
                    <span class="radio-select-slider" v-for="(radio, index) in invExpList">
                        <input type="radio" :value="radio.value" :id="'inv-exp-commodity-radio-btn' + index" name="Client[client_inv_exp_commodity]" v-validate="{required_choose: true, required: true}" v-model="client_inv_exp_commodity" :data-vv-as="[index == 0 ? '商品投資經驗之年數' : null]">
                        <label :for="'inv-exp-commodity-radio-btn' + index"><span>{{radio.displayName}}</span></label>
                    </span>
               </div>
               <span :class="{'invalid': errors.has('signup_agent_form.Client[client_inv_exp_commodity]'), 'valid': !errors.has('signup_agent_form.Client[client_inv_exp_commodity]')}">{{errors.first('signup_agent_form.Client[client_inv_exp_commodity]')}}<span v-if="(!errors.has('signup_agent_form.Client[client_inv_exp_commodity]') && client_inv_exp_commodity.length > 0)">商品投資經驗之年數</span></span>
            </div>
            <div class="one-line slider">
              <span v-if="client_inv_exp_other == ''">其他投資經驗之年數</span>
              <span v-if="client_inv_exp_other && client_inv_exp_other === value.value" v-for="value in invExpList">
                  {{value.value}}
              </span>
               <div class="radio-select-slider-container progressive seven">
                    <span class="radio-select-slider" v-for="(radio, index) in invExpList">
                        <input type="radio" :value="radio.value" :id="'inv-exp-other-radio-btn' + index" name="Client[client_inv_exp_other]" v-validate="{required_choose: true, required: true}" v-model="client_inv_exp_other" :data-vv-as="[index == 0 ? '其他投資經驗之年數' : null]">
                        <label :for="'inv-exp-other-radio-btn' + index"><span>{{radio.displayName}}</span></label>
                    </span>
               </div>
               <span :class="{'invalid': errors.has('signup_agent_form.Client[client_inv_exp_other]'), 'valid': !errors.has('signup_agent_form.Client[client_inv_exp_other]')}">{{errors.first('signup_agent_form.Client[client_inv_exp_other]')}}<span v-if="(!errors.has('signup_agent_form.Client[client_inv_exp_other]') && client_inv_exp_other.length > 0)">其他投資經驗之年數</span></span>
            </div>
        </fieldset>
        <fieldset>
            <legend>您預期的投資額</legend>
            <div class="one-line slider">
              <span v-if="client_ept_inv_amount == ''">預期投資數額（美元）</span>
              <span v-if="client_ept_inv_amount && client_ept_inv_amount === value.value" v-for="value in usdAmountList[0].option">
                  {{value.displayName}}
              </span>
               <div class="radio-select-slider-container range">
                    <span class="radio-select-slider" v-for="(radio, index) in usdAmountList[0].option">
                        <input type="radio" :value="radio.value" :id="'ept-inv-amount-radio-btn' + index" name="Client[client_ept_inv_amount]" v-validate="{required_choose: true, required: true}" v-model="client_ept_inv_amount" :data-vv-as="[index == 0 ? '預期投資數額（美元）' : null]">
                        <label :for="'ept-inv-amount-radio-btn' + index"></label>
                        <span class="switcher">|||</span>
                    </span>
                   <span class="scale-container">
                       <span  v-for="scale in usdAmountList[0].scale"><span>{{scale.displayName}}</span></span>
                   </span>
               </div>
               <span :class="{'invalid': errors.has('signup_agent_form.Client[client_ept_inv_amount]'), 'valid': !errors.has('signup_agent_form.Client[client_ept_inv_amount]')}">{{errors.first('signup_agent_form.Client[client_ept_inv_amount]')}}<span v-if="(!errors.has('signup_agent_form.Client[client_ept_inv_amount]') && client_ept_inv_amount.length > 0)">預期投資數額（美元）</span></span>
            </div>
        </fieldset>
    </div>
</template>

<script>
    export default {
        inherit: true,
        inject: ['$validator'],
        name: "formThree",
        components: {},
        data: () => ({
            /* v-model below, form core */
            client_annual_income: "",
            client_net_current_assets: "",
            client_total_assets: "",
            client_inv_kno: "",
            client_inv_exp_exchange: "",
            client_inv_exp_option: "",
            client_inv_exp_securities: "",
            client_inv_exp_futures: "",
            client_inv_exp_fund: "",
            client_inv_exp_bonds: "",
            client_inv_exp_commodity: "",
            client_inv_exp_other: "",
            client_ept_inv_amount: "",
            /* usd amount list */
            usdAmountList: [{
                scale: [
                    {order: "1", displayName: "更少"},
                    {order: "2", displayName: "五萬"},
                    {order: "3", displayName: "十萬"},
                    {order: "4", displayName: "十五萬"},
                    {order: "5", displayName: "二十萬"},
                    {order: "6", displayName: "一百萬"},
                    {order: "7", displayName: "更多"}
                ],
                option: [
                    {order: "1", displayName: "＜US$50,000", value: "<$50,000"},
                    {order: "2", displayName: "US$50,000 - US$99,999", value: "$50,000-$99,999"},
                    {order: "3", displayName: "US$100,000 - US$149,999", value: "$100,000-$149,999"},
                    {order: "4", displayName: "US$150,000 - US$199,999", value: "$150,000-$199,999"},
                    {order: "5", displayName: "US$200,000 - US$1,000,000", value: "$200,000-$1,000,000"},
                    {order: "6", displayName: "＞US$1,000,000", value: ">$1,000,000"}
                ]
            }],
            /* inv knowladge list */
            invKnoList: [
                {order: "1", displayName: "一般", value: "General"},
                {order: "2", displayName: "良好", value: "Good"},
                {order: "3", displayName: "豐富", value: "Rich"}
            ],
            /* inv experence list */
            invExpList: [
                {order: "1", displayName: "0", value: "0"},
                {order: "2", displayName: "1", value: "1"},
                {order: "3", displayName: "2", value: "2"},
                {order: "4", displayName: "3", value: "3"},
                {order: "5", displayName: "4", value: "4"},
                {order: "6", displayName: "5", value: "5"},
                {order: "7", displayName: "更多", value: "＞5"}
            ]
        }),
    }
</script>

<style lang="scss" scoped>
    .radio-select-slider-container.range{
        label{
            width: calc(100%/6);
        }
        .scale-container{
            > span:first-of-type:before{
                left: 0;
            }
            > span:last-of-type:before{
                right: 0;
            }
            @for $i from 1 through 7{
                > span:nth-of-type(#{$i}){
                    > span{
                        left: 100% / (6) * ($i - 1);
                        transform: translateX(-50%);
                    }
                }
                > span:nth-of-type(#{$i}):before{
                    left: 100% / 6 * ($i - 1);
                }
            }
            > span:first-of-type{
                > span{
                    transform: translateX(0);
                }
            }
            > span:last-of-type{
                > span{
                    transform: translateX(-100%);
                }
            }
        }
        .switcher{
            width: calc(100%/6);
        }
        @for $i from 1 through 7{
            .radio-select-slider:nth-of-type(#{$i}) input[type="radio"]:checked + label + .switcher{
                opacity: 1;
                left: 100%/6 * $i - 100%/6;
            }
        }
    }
    .radio-select-slider-container.progressive{
        &.three{
            .radio-select-slider{
                &:first-of-type > label{
                    text-align: left;
                }
                &:last-of-type > label{
                    text-align: right;
                }
                @for $i from 1 through 3{
                    &:nth-of-type(#{$i}){
                        left: 100%/3 * ($i - 1);
                        input[type="radio"]:checked ~ label{
                            &:before{
                                width: (100% * (3 / 2)) * ($i - 1);
                                left: -100% * ($i - 1);
                            }
                            &:after{
                                left: (100% / (3 - 1)) * ($i - 1);
                            }
                        }
                        label > span:before{
                            left: (100% / (3 - 1)) * ($i - 1);
                        }
                    }
                }
                label{
                    width: calc(100% / 3);
                }
            }
        }
        &.seven{
            .radio-select-slider{
                @for $i from 1 through 7{
                    &:nth-of-type(#{$i}){
                        left: 100%/7 * ($i - 1);
                        input[type="radio"]:checked ~ label{
                            &:before{
                                width: (100% * (7 / 6)) * ($i - 1);
                                left: -100% * ($i - 1);
                            }
                            &:after{
                                left: (100% / (7 -  1)) * ($i - 1);
                            }
                        }
                        label > span:before{
                            left: (100% / (7 - 1)) * ($i - 1);
                        }
                        label > span{
                            padding-left: 100%/6.5 * ($i - 1);
                        }
                    }
                }
                label{
                    width: calc(100% / 7);
                    text-align: left;
                }
                &:last-of-type > label{
                    text-align: right;
                    > span{
                        padding-left: 0;
                    }
                }
            }
        }
    }
</style>
